<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 11:21:44
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-09-09 15:45:32
 * @name: 我的售后列表
 * @Description: 我的售后列表
 * @FilePath: \project\src\views\index\afterSale\afterSaleList\afterSaleList.vue
 * @Author: desktop
-->
<template>
  <div class="afterSaleList" id="afterSaleList">
    <div class="container">
      <table-search-form title="我的售后列表">
        <template v-slot:searchForm>
          <div class="search-form">
            <div class="search-line">
              <div class="search-label"><font>琴号</font></div>
              <div class="search-content">
                <el-input
                  size="mini"
                  v-model="afterSaleListView.searchForm.piano_no"
                  placeholder="请输入琴号搜索"
                  @blur="setFocus()"
                  @keyup.native.enter="afterSaleListView.onQuery()"
                ></el-input>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>型号</font></div>
              <div class="search-content">
                <el-input
                  size="mini"
                  v-model="afterSaleListView.searchForm.piano_model"
                  placeholder="请输入型号搜索"
                  @blur="setFocus()"
                  @keyup.native.enter="afterSaleListView.onQuery()"
                ></el-input>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>琴行名称</font></div>
              <div class="search-content">
                <el-input
                  size="mini"
                  v-model="afterSaleListView.searchForm.agency_name"
                  placeholder="请输入琴行名称搜索"
                  @blur="setFocus()"
                  @keyup.native.enter="afterSaleListView.onQuery()"
                ></el-input>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>问题描述</font></div>
              <div class="search-content">
                <el-input
                  size="mini"
                  v-model="afterSaleListView.searchForm.question"
                  placeholder="请输入问题描述关键字搜索"
                  @blur="setFocus()"
                  @keyup.native.enter="afterSaleListView.onQuery()"
                ></el-input>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>当前状态</font></div>
              <div class="search-content">
                <div class="search-checkbox-group">
                  <el-radio-group
                    size="mini"
                    v-model="afterSaleListView.searchForm.type"
                    @change="setFocus()"
                  >
                    <el-radio-button
                      v-for="item of afterSaleListView.typeList"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.text }}
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>乐器类别</font></div>
              <div class="search-content">
                <div class="search-checkbox-group">
                  <el-radio-group
                    size="mini"
                    v-model="afterSaleListView.searchForm.musical"
                    @change="setFocus()"
                  >
                    <el-radio-button
                      v-for="item of afterSaleListView.musicals"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.text }}
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>问题类型</font></div>
              <div class="search-content">
                <div class="search-checkbox-group">
                  <el-radio-group
                    size="mini"
                    v-model="afterSaleListView.searchForm.issue_name"
                    @change="setFocus()"
                  >
                    <el-radio-button
                      v-for="item of afterSaleListView.issue_names"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.text }}
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>发起时间</font></div>
              <div class="search-content">
                <el-date-picker
                  :editable="false"
                  size="mini"
                  value-format="yyyy-MM-dd"
                  v-model="afterSaleListView.searchForm.date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="setFocus()"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="btn-group">
              <el-button
                size="mini"
                icon="el-icon-search"
                type="primary"
                id="filterSearch"
                @keyup.enter="afterSaleListView.onQuery()"
                @click="afterSaleListView.onQuery()"
                >搜索</el-button
              >
              <el-button
                size="mini"
                icon="el-icon-refresh"
                plain
                @click="afterSaleListView.initData()"
                >刷新</el-button
              >
            </div>
          </div>
        </template>
        <template v-slot:head></template>
        <template v-slot:table>
          <el-table
            id="table"
            :data="afterSaleListView.tableData"
            v-loading="afterSaleListView.tableLoading"
            tooltip-effect="light"
            element-loading-text="数据加载中"
            fit
            border
            :header-cell-style="{
              'background-color': $scssVars['Vars-background-bar-normal'],
              color: '#666',
            }"
            :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
          >
            <el-table-column align="center" prop="id" label="ID" width="100">
            </el-table-column>
            <el-table-column
              align="center"
              prop="run_process_create_time"
              label="发起时间"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="agency_name"
              label="琴行名称"
              width="240"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="musical"
              label="乐器类别"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="piano_model"
              label="型号"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="piano_no"
              label="琴号"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="issue_name"
              label="问题类型"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="positions"
              label="问题部位"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="questions"
              label="具体问题"
              width="240"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="statuText"
              label="当前状态"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="afterSaleListView.toDetail(scope.row)"
                  >查看详情</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="afterSaleListView.destory(scope.row)"
                  v-if="
                    Number(scope.row.end_flow) === 1 &&
                    Number(scope.row.run_status) === 0
                  "
                  >废单</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  v-if="Number(afterSaleListView.allow_print) === 1"
                  @click="doOutput(scope.row)"
                  >导出</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-slot:pagination>
          <Pagination
            class="pagination"
            v-if="afterSaleListView.pagination.page"
            :page.sync="afterSaleListView.pagination.page"
            :page-size.sync="afterSaleListView.pagination.limit"
            :total="afterSaleListView.tableTotal"
          >
          </Pagination>
        </template>
      </table-search-form>
    </div>
    <dialog-output ref="output"></dialog-output>
  </div>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import dialogOutput from "@/components/afterSale/dialog-output.vue";
import afterSaleListView from "./afterSaleList.view.js";
import Pagination from "@/components/public/Pagination.vue";
import { getEventBus } from "@/config/eventBus.config.js";
import { indexRouterLinkConfig } from "@/config/indexRouterLink.config";
import { role_list } from "@/config/role.config";
import { debounceation } from "@/utils/decorator.js";
export default {
  name: "indexAfterSaleList",
  components: {
    tableSearchForm,
    dialogOutput,
    Pagination,
  },
  data() {
    return {
      pageScroll: 0,
      tableScroll: 0,
      afterSaleListView: new afterSaleListView(),
    };
  },
  //记录离开时的位置
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.pageScroll = document.querySelector("#afterSaleList").scrollTop;
    this.tableScroll = document.querySelector(
      "#table .el-table__body-wrapper"
    ).scrollLeft;
    next();
  },
  watch: {
    //分页数据发送变化查询表格数据
    "afterSaleListView.pagination": {
      handler(nv, ov) {
        nv.page && this.afterSaleListView.getTableData();
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.afterSaleListView.initData();
    this.$EventBus.$on(getEventBus("我的售后列表发生变更"), () => {
      this.afterSaleListView.getTableData();
    });
  },
  beforeDestroy() {
    this.$EventBus.$off(getEventBus("我的售后列表发生变更"));
  },
  // 存在上一个页面,且上一个页面不是本页面的父页面的子级页面,重置数据
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let needRefresh = false;
      indexRouterLinkConfig.forEach((x) => {
        x.children.forEach((y) => {
          if (y.url === from.path || y.url === from.redirectedFrom) {
            needRefresh = true;
          }
        });
      });
      if (needRefresh) {
        vm.afterSaleListView.initData();
      } else {
        vm.$nextTick(() => {
          document.querySelector("#afterSaleList").scrollTop = vm.pageScroll;
          document.querySelector("#table .el-table__body-wrapper").scrollLeft =
            vm.tableScroll;
        });
      }
    });
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设焦点在按钮上
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开导出弹窗
     */
    @debounceation(300)
    doOutput(row) {
      this.$refs.output.open(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.afterSaleList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
  }
}
</style>